export default {
  REACT_APP_API_ENDPOINT: "https://capstone-spaced-repetition.herokuapp.com/api",
  REACT_APP_TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY,
}
